module.exports = __webpack_public_path__ + "img/tab-message.b3f12227.png";